require("./dist/editor.min.css");
module.exports = require("./dist/wysiwyg.min.js");
require("./dist/images/header-bg.gif");
require("./dist/images/icons.png");
require("./dist/images/resize.gif");


/*****************
 ** WEBPACK FOOTER
 ** ngWYSIWYG (bower component)
 ** module id = 382
 ** module chunks = 1
 **/